import { useMutation, useQueryClient } from 'react-query';

import MUTATION_KEYS from 'config/api/MUTATION_KEYS';

import { invalidateOwnerAssetRopaQueries } from './invalidateOwnerAssetRopaQueries';
import { startDpiaReassessment } from './startDpiaReassessment';

type ReassessVariables = {
  apaId: number;
  reason: string;
};

const useDpiaReassess = (organizationId?: number) => {
  const queryClient = useQueryClient();

  return useMutation(
    MUTATION_KEYS.DPIA_REQUEST_REASSESS,
    async ({ apaId, reason }: ReassessVariables) => {
      if (!organizationId) {
        throw new Error('Missing organization');
      }

      return startDpiaReassessment(organizationId, apaId, reason);
    },
    {
      onSuccess: () => {
        invalidateOwnerAssetRopaQueries(queryClient, organizationId);
      },
    },
  );
};

export default useDpiaReassess;
